export default __webpack_public_path__ + "static/zzp-db78265b952f341de697785c9241cbcd8acbf473a3d429ca8f7a104c2b5f529f.png";